import * as React from 'react';
import { Modal } from '@watcherr/ui';
import { t } from '~/i18n';
import styles from "./AlertCallModal.module.css"
import classnames from "classnames"
import { formatPhoneNumberIntl } from 'react-phone-number-input';

interface AlertResolveModalProps {
  phoneNumbers: { label: string, value: string }[];
  onClose: () => void;
  onCall: () => void;
}

const AlertCallModal: React.FC<AlertResolveModalProps> = ({
  phoneNumbers,
  onClose,
  onCall,
}) => {
  return (
    <Modal onClose={onClose} style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t(`alert.call.modal.title`)}</h3>

      <ul>
        {phoneNumbers.map(item => (
          <div className={classnames(styles.Input, "mb-30")}>
            <label htmlFor={item.value}>
              {item.label}
            </label>
            <a onClick={onCall} id={item.value} className={styles.Input} href={`tel:${item.value}`}>{formatPhoneNumberIntl(item.value)}</a>
          </div>
        ))}
      </ul>
    </Modal>
  );
};

export default AlertCallModal;
